import { Box, Typography } from '@wishket/design-system';
import Link from 'next/link';
import { ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';

interface UsageCardProps {
  title: string;
  description: string;
  imageComponent: ReactNode;
  link: string;
}

const UsageCard = ({
  title,
  description,
  imageComponent,
  link,
}: UsageCardProps) => {
  return (
    <Link
      href={link}
      className={twJoin(
        'flex flex-col gap-6 rounded-2xl bg-primary-10 px-5 pb-5 pt-6',
        'tablet:w-full desktop:gap-12 desktop:p-8',
        'duration-200 ease-in desktop:hover:-translate-y-[5%]'
      )}
      target="_blank"
    >
      <Box className="flex flex-col gap-1 desktop:gap-3">
        <Typography variant="body1" className="font-medium text-primary">
          {title}
        </Typography>
        <Typography
          variant="body1"
          className="whitespace-pre-line break-keep font-bold text-gray-900 desktop:typo-subTitle2"
        >
          {description}
        </Typography>
      </Box>
      <Box className="flex justify-end">{imageComponent}</Box>
    </Link>
  );
};

export default UsageCard;
